// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB_QwMqCPvI08TY4niNmseGcvHX-FmwGr0",
    authDomain: "myadwisor.firebaseapp.com",
    databaseURL: "https://myadwisor.firebaseio.com",
    projectId: "myadwisor",
    storageBucket: "myadwisor.appspot.com",
    messagingSenderId: "100325092767"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts